import { html, nothing } from 'lit';
export const nothingTemplate = html `${nothing}`;
